export default __webpack_public_path__ + "static/media/team-foto4-color.1ca3c5f1.png";